<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActive"
  >
    <div id="loading-add-compliance-sidebar" class="vs-con-loading__container">
      <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ $t('add') }} {{ $t('new') }} {{ $t('element') }}</h4>
        <feather-icon
          icon="XIcon"
          @click.stop="close"
          class="cursor-pointer"
        ></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>

      <component
        :is="scrollbarTag"
        class="scroll-area--data-list-add-new"
        :settings="settings"
        :key="$vs.rtl"
      >
        <div class="p-6">
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{ $t('client') }}</label>
              <v-select
                :options="clients"
                label="ShortName"
                :reduce="(client) => client.ClientId"
                v-model="client"
                v-validate="'required'"
                name="client"
                class="w-full"
                @input="changeClient"
              />
              <span class="text-danger text-sm" v-show="errors.has('client')">{{
                errors.first('client')
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label> {{ $t('building_number') }}</label>
              <v-select
                :options="facilityOptions"
                label="name"
                :reduce="(f) => f.id"
                v-model="facility"
                v-validate="'required'"
                name="facility"
                class="w-full"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('facility')"
                >{{ errors.first('facility') }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{ $t('category') }}</label>
              <v-select
                :options="categories"
                label="name"
                :reduce="(category) => category.id"
                v-model="category"
                v-validate="'required'"
                name="category"
                class="w-full"
                @input="changeCategory"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('category')"
                >{{ errors.first('category') }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{ $t('vendor') }}</label>
              <v-select
                :options="vendorOptions"
                label="name"
                :reduce="(vendor) => vendor.id"
                v-model="vendor"
                v-validate="'required'"
                name="vendor"
                class="w-full"
              />
              <span class="text-danger text-sm" v-show="errors.has('vendor')">{{
                errors.first('vendor')
              }}</span>
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <add-vendor
                name="add-vendor-compliance"
                :title="$t('add_new_vendor')"
                :btnText="$t('add_new_vendor')"
                btnClass="w-full"
                @success="addVendor"
                :category="selectedCategory"
              />
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{ $t('title') }}</label>
              <v-select
                :options="titleOptions"
                label="name"
                :reduce="(title) => title.id"
                v-model="title"
                v-validate="'required'"
                name="title"
                class="w-full"
              />
              <span class="text-danger text-sm" v-show="errors.has('title')">{{
                errors.first('title')
              }}</span>
            </div>
          </div>

          <input-date
            v-model="expirationDate"
            :value="expirationDate"
            :label="$t('expiration_date')"
          />

          <!-- <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{}}</label>
            
              <vs-input
                class="w-full"
                type="text"
                v-mask="'##/##/####'"
                v-model="expirationDate"
                name="expirationDate"
                v-validate="'required'"
              /> 
              <span
                class="text-danger text-sm"
                v-show="errors.has('expirationDate')"
              >{{ errors.first('expirationDate') }}</span>
            </div>
          </div> -->

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{ $t('notify') }} ({{ $t('days') }})</label>
              <vs-input-number
                min="1"
                v-model="notifyDays"
                name="notifyDays"
                class="w-full"
                v-validate="'required'"
                max="999"
                maxlength="3"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('notifyDays')"
                >{{ errors.first('notifyDays') }}</span
              >
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{ $t('term') }} ({{ $t('months') }})</label>
              <vs-input-number
                min="1"
                v-model="term"
                name="term"
                class="w-full"
                v-validate="'required'"
                max="999"
                maxlength="3"
              />
              <span class="text-danger text-sm" v-show="errors.has('term')">{{
                errors.first('term')
              }}</span>
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{ $t('cost') }} (USD)</label>
              <vs-input
                type="number"
                v-model="cost"
                name="cost"
                class="w-full"
                v-validate="'required'"
              />
              <span class="text-danger text-sm" v-show="errors.has('cost')">
                {{ errors.first('cost') }}
              </span>
            </div>
          </div>
          <!-- <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{$t('frequency')}}</label>
              <v-select
                :options="frequencies"
                label="name"
                :reduce="frequency => frequency.id"
                v-model="frequency"
                v-validate="'required'"
                name="frequency"
                class="w-full"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('frequency')"
              >{{ errors.first('frequency') }}</span>
            </div>
          </div> -->

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label for="frequency" text-align="right">{{
                $t('frequency')
              }}</label>
              <!-- base-class="custom-auto" -->
              <autocomplete
                :search="search"
                :placeholder="$t('search_frequency')"
                :get-result-value="getResultValue"
                @submit="handleSubmit"
                ref="autocomplete"
                class="auto-catalog"
              ></autocomplete>
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{ $t('escalation_rate') }} (%)</label>
              <vs-input
                v-model="escalationRate"
                name="escalationRate"
                class="w-full"
                v-validate="'required'"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('escalationRate')"
                >{{ errors.first('escalationRate') }}</span
              >
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{ $t('comments') }}</label>
              <vs-input
                class="w-full"
                type="text"
                v-model="comments"
                name="comments"
                :placeholder="$t('comments')"
                autocomplete="off"
              />
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{ $t('compliance_file') }}</label>
              <!-- <input
                type="file"
                name="file"
                label="File"
                ref="file"
                class="w-full"
                @change="changeFile"
              /> -->
              <UploadFile
                list
                v-model="file"
                btnColor="primary"
                class="w-full"
                btnClass="w-full"
                accept="application/pdf"
              />
            </div>
          </div>

          <template v-if="extraFields">
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <label>{{ $t('sq_ft') }}</label>
                <vs-input
                  type="number"
                  v-model="sqft"
                  name="sqft"
                  class="w-full"
                  v-validate="'required'"
                />
                <span class="text-danger text-sm" v-show="errors.has('sqft')">{{
                  errors.first('sqft')
                }}</span>
              </div>
            </div>

            <input-date
              v-model="extensionDate"
              :value="extensionDate"
              :label="$t('extension_date')"
            />
            <!-- <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{$t('extension_date')}}</label>
              <vs-input
                class="w-full"
                type="text"
                v-mask="'##/##/####'"
                v-model="extensionDate"
                name="extensionDate"
                v-validate="'required'"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('extensionDate')"
              >{{ errors.first('extensionDate') }}</span>
            </div>
          </div> -->

            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <label>{{ $t('lease_rate') }}</label>
                <vs-input
                  class="w-full"
                  type="number"
                  v-model="leaseRate"
                  name="leaseRate"
                  v-validate="'required'"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('leaseRate')"
                  >{{ errors.first('leaseRate') }}</span
                >
              </div>
            </div>

            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <label>{{ $t('escalation_period') }}</label>
                <vs-input
                  class="w-full"
                  type="number"
                  v-model="escalationPeriod"
                  name="escalationPeriod"
                  v-validate="'required'"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('escalationPeriod')"
                  >{{ errors.first('escalationPeriod') }}</span
                >
              </div>
            </div>

            <!-- <input-date 
              v-model="dueDate" 
              :value="dueDate"
              :label="$t('due_date')" /> -->

            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <label>{{ $t('due_date') }}</label>
                <vs-input-number
                  min="1"
                  v-model="dueDate"
                  name="dueDate"
                  class="w-full"
                  v-validate="'required'"
                  max="31"
                  maxlength="3"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('notifyDays')"
                  >{{ errors.first('notifyDays') }}</span
                >
              </div>
            </div>

            <!-- <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{$t('insurance_expiration_date')}}</label>
              <vs-input
                class="w-full"
                type="text"
                v-mask="'##/##/####'"
                v-model="insuranceExpirationDate"
                name="insuranceExpirationDate"
                v-validate="'required'"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('insuranceExpirationDate')"
              >{{ errors.first('insuranceExpirationDate') }}</span>
            </div>
          </div> -->

            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <label>{{ $t('maintenance') }}</label>
                <vs-input
                  class="w-full"
                  type="number"
                  v-model="maintenance"
                  name="maintenance"
                  v-validate="'required'"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('maintenance')"
                  >{{ errors.first('maintenance') }}</span
                >
              </div>
            </div>

            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <label>{{ $t('property_tax') }}</label>
                <vs-input
                  class="w-full"
                  type="number"
                  v-model="propertyTax"
                  name="propertyTax"
                  v-validate="'required'"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('propertyTax')"
                  >{{ errors.first('propertyTax') }}</span
                >
              </div>
            </div>

            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <label>{{ $t('options') }}</label>
                <vs-input
                  class="w-full"
                  type="text"
                  v-model="options"
                  name="options"
                  :placeholder="$t('options')"
                />
              </div>
            </div>

            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <label>{{ $t('insurance_file') }}</label>
                <!-- <input
                type="file"
                name="file"
                label="File"
                ref="file"
                class="w-full"
                @change="changeFile"
              /> -->
                <UploadFile
                  v-model="insuranceFile"
                  list
                  btnColor="primary"
                  class="w-full"
                  btnClass="w-full"
                  accept="application/pdf"
                />
              </div>
            </div>

            <div v-if="insuranceFile.length > 0">
              <div class="vx-row mb-2">
                <div class="vx-col w-full">
                  <label>{{ $t('insurance_company') }}</label>
                  <v-select
                    :options="vendorOptions"
                    label="name"
                    :reduce="(vendor) => vendor.id"
                    v-model="insuranceCompany"
                    v-validate="'required'"
                    name="insuranceCompany"
                    class="w-full"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('insuranceCompany')"
                    >{{ errors.first('insuranceCompany') }}</span
                  >
                </div>
              </div>
              <input-date
                v-model="insuranceExpirationDate"
                :value="insuranceExpirationDate"
                :label="$t('insurance_expiration_date')"
              />
              <div class="vx-row mb-2">
                <div class="vx-col w-full">
                  <label>{{ $t('insured_amount') }}</label>
                  <vs-input
                    class="w-full"
                    type="number"
                    v-model="insuredAmount"
                    name="insuredAmount"
                    v-validate="'required'"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('insuredAmount')"
                    >{{ errors.first('insuredAmount') }}</span
                  >
                </div>
              </div>
            </div>
          </template>
        </div>
      </component>

      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button
          class="mr-6"
          @click.stop.prevent="submit()"
          :disabled="!validForm"
          >{{ $t('submit') }}</vs-button
        >
        <vs-button type="border" color="danger" @click.stop="close">{{
          $t('cancel')
        }}</vs-button>
      </div>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Autocomplete from '@trevoreyre/autocomplete-vue'
import vSelect from 'vue-select'
import moment from 'moment'
import InputDate from '@/components/custom/InputDate'
import compliance from '@/http/requests/compliance/index.js'
import AddVendor from '@/views/components/AddVendor'
import UploadFile from '@/views/components/UploadFile'
export default {
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
    InputDate,
    Autocomplete,
    AddVendor,
    UploadFile,
  },
  props: {
    clients: {
      default: () => [],
    },
    facilities: {
      default: () => [],
    },
    categories: {
      default: () => [],
    },
    vendors: {
      default: () => [],
    },
    titles: {
      default: () => [],
    },
    frequencies: {
      default: () => [],
    },
  },
  data() {
    return {
      extraFields: 0,
      client: '',
      facility: '',
      category: '',
      vendor: '',
      title: '',
      expirationDate: '',
      notifyDays: 1,
      term: 1,
      cost: 0,
      escalationRate: 0,
      comments: '',
      file: [],
      sqft: 0,
      extensionDate: '',
      leaseRate: 0,
      escalationPeriod: 0,
      dueDate: '',
      options: '',
      insuranceCompany: '',
      insuredAmount: 0,
      insuranceExpirationDate: '',
      insuranceFile: [],
      maintenance: 0,
      propertyTax: 0,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      frequencyOptions: [],
    }
  },
  computed: {
    isSidebarActive() {
      compliance.getFrequencies().then((res) => {
        this.frequencyOptions = res.data.frequencies
      })
      return this.$store.state.sidebar === 'addCompliance'
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    },
    isFormValid() {
      return true
    },
    facilityOptions() {
      let list = this.facilities.filter((f) => f.client_id === this.client)
      return list.length > 0
        ? list
        : [
            {
              id: '00',
              name: this.$i18n.messages[this.$i18n.locale].no_results,
            },
          ]
    },
    titleOptions() {
      let list = this.titles.filter(
        (t) => t.category_contract_id === this.category
      )
      return list.length > 0
        ? list
        : [
            {
              id: '00',
              name: this.$i18n.messages[this.$i18n.locale].no_results,
            },
          ]
    },
    vendorOptions() {
      let list = this.vendors
      if (this.category != '15') {
        list = this.vendors.filter(
          (v) => v.category_contract_id === this.category
        )
      }
      return list.length > 0
        ? list
        : [
            {
              id: '00',
              name: this.$i18n.messages[this.$i18n.locale].no_results,
            },
          ]
    },
    validForm() {
      return (
        this.file.length > 0 &&
        this.expirationDate !== '' &&
        this.title !== '00' &&
        this.facility !== '00' &&
        this.$refs.autocomplete.core.value != ''
      )
    },
    frequency() {
      return this.$refs.autocomplete.core.value
    },
    selectedCategory() {
      return this.categories.find((c) => c.id === this.category)
    },
    currentCategory: function () {
      return this.categories.filter((f) => f.id === this.category)
    },
  },
  watch: {
    isSidebarActive(val) {
      if (val) {
        this.init()
      }
    },
  },
  methods: {
    init() {
      this.client = this.clients[0].ClientId
      this.category = this.categories[0].id
      this.vendor = this.vendorOptions[0].id
      //this.frequency = this.frequencies[0].id
      this.changeClient()
      this.changeCategory()
      //default values
      this.expirationDate = ''
      this.notifyDays = 0
      this.term = 0
      this.cost = 0
      this.escalationRate = 0
      this.comments = ''
      this.file = []
    },
    changeClient() {
      this.facility = this.facilityOptions[0].id
    },
    changeCategory() {
      this.extraFields = this.currentCategory[0].show_detail == 1 ? true : false
      this.title = this.titleOptions[0].id
      this.vendor = this.vendorOptions[0].id
      if (this.extraFields) {
        this.sqft = 0
        this.extensionDate = ''
        this.leaseRate = 0
        this.escalationPeriod = 0
        this.dueDate = 1
        this.options = ''
        this.insuranceCompany = this.vendorOptions[0].id
        this.insuredAmount = 0
        this.insuranceExpirationDate = ''
        this.insuranceFile = []
        this.maintenance = 0
        this.propertyTax = 0
      }
    },
    close() {
      this.$store.dispatch('toggleSidebar', '')
    },
    submit() {
      this.openLoading()
      let form = new FormData()
      form.append('client', this.client)
      form.append('facility', this.facility)
      form.append('category', this.category)
      form.append('vendor', this.vendor)
      form.append('title', this.title)
      form.append('expiration_date', this.expirationDate)
      form.append('notify_days', this.notifyDays)
      form.append('term', this.term)
      form.append('cost', this.cost)
      form.append('frequency', this.frequency)
      form.append('escalation_rate', this.escalationRate)
      form.append('comments', this.comments)
      if (this.file.length > 0) {
        form.append('file', this.file[0])
      }
      
      this.$refs.autocomplete.value = ''
      if (this.extraFields) {
        form.append('extra_fields', this.extraFields)
        form.append('sq_ft', this.sqft)
        form.append('extension_date', this.extensionDate)
        form.append('lease_rate', this.leaseRate)
        form.append('escalation_period', this.escalationPeriod)
        form.append('due_date', this.dueDate)
        form.append('options', this.options)
        form.append('maintenance', this.maintenance)
        form.append('property_tax', this.propertyTax)

        if (this.insuranceFile.length > 0) {
          form.append('insurance_company', this.insuranceCompany)
          form.append('insured_amount', this.insuredAmount)
          form.append('insurance_expiration_date', this.insuranceExpirationDate)
          form.append('insurance_file', this.insuranceFile[0])
        }
      }
      this.$store
        .dispatch('compliance/add', form)
        .then((res) => {
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Item Added',
          })
          this.closeLoading()
          this.close()
        })
        .catch((err) => {
          this.closeLoading()
          if (422 === err.response.status) {
            const errors = err.response.data.errors
            const errorArray = Object.keys(errors).map(function (key) {
              return [key, errors[key]]
            })
            errorArray.forEach((element) => {
              this.$vs.notify({
                color: 'danger',
                title: 'Alert',
                text: element[1][0],
              })
            })
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Alert',
              text: 'SERVER ERROR',
            })
          }
        })
    },
    openLoading() {
      this.$vs.loading({
        container: '#loading-add-compliance-sidebar',
        scale: 0.6,
      })
    },
    closeLoading() {
      this.$vs.loading.close(
        '#loading-add-compliance-sidebar > .con-vs-loading'
      )
    },
    search(input) {
      return this.frequencyOptions.filter((item) =>
        item.name.toLowerCase().includes(input.toLowerCase())
      )
    },
    getResultValue(result) {
      return result.name
    },
    handleSubmit(result) {
      this.$refs.autocomplete.core.value = result.name
    },
    addVendor() {
      this.vendor = this.vendorOptions[0].id
    },
  },
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
